import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "@/data/site";
import { SectionTag } from "@/components/Kinetic";
import { EASE, viewport } from "@/lib/motion";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.8", "end 0.6"],
  });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section
      id="process"
      ref={ref}
      data-testid="process"
      className="relative border-t border-[#1f1f1f] bg-[#0d0d0d] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1700px] px-5 md:px-10">
        <SectionTag num="04 / PROCESS">THE TIMELINE</SectionTag>

        <h2 className="mb-16 max-w-3xl font-display text-3xl font-black uppercase leading-[0.9] tracking-[-0.04em] text-[#e5e5e5] md:mb-24 md:text-[3.6vw]">
          FIVE STAGES.
          <br />
          NO <span className="text-[#d4ff00]">GUESSWORK.</span>
        </h2>

        <div className="relative pl-8 md:pl-16">
          <div className="absolute left-0 top-0 h-full w-[1px] bg-[#1f1f1f]">
            <motion.div style={{ height }} className="w-full bg-[#d4ff00]" />
          </div>

          {PROCESS.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={viewport}
              transition={{ duration: 0.85, ease: EASE, delay: i * 0.06 }}
              data-testid={`process-step-${s.num}`}
              className="group relative grid grid-cols-12 gap-4 border-b border-[#1f1f1f] py-10 md:py-14"
            >
              <span className="absolute -left-8 top-12 h-[1px] w-5 bg-[#1f1f1f] transition-colors duration-500 group-hover:bg-[#d4ff00] md:-left-16 md:w-12" />
              <span className="col-span-12 label text-[#d4ff00] md:col-span-2">
                {s.num}
              </span>
              <h3 className="col-span-12 font-display text-3xl font-black uppercase tracking-[-0.03em] text-[#e5e5e5] transition-transform duration-500 group-hover:translate-x-2 md:col-span-4 md:text-[2.4vw]">
                {s.name}
              </h3>
              <div className="col-span-12 md:col-span-6">
                <p className="font-display text-base font-bold text-[#e5e5e5] md:text-lg">
                  {s.q}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-[#a3a3a3]">
                  {s.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
